import { useState, useEffect, useContext } from "react";
import { styled } from "@mui/material/styles";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Content from "./Content";
import { Box, CircularProgress, CssBaseline } from "@mui/material";
import { AppContextProvider } from "./context";
import AuthContext from "../auth/context";
import api from "../services/api";

export default function Container({ match, location, history }) {
  const [validandoAcesso, setValidandoAcesso] = useState(true);
  const [acessoOk, setAcessoOk] = useState(false);
  const [openMenu, setOpenMenu] = useState(window.innerWidth >= 800);
  const [currentGroup, setCurrentGroup] = useState({});
  const [currentRoute, setCurrentRoute] = useState(
    location.pathname.replace("/app/", "")
  );

  const { usuario } = useContext(AuthContext);
  const [menus, setMenus] = useState(null);

  useEffect(() => {
    // //window.addEventListener("resize", () => setScreenWidth(window.innerWidth));

    const menusSalvos = JSON.parse(
      localStorage.getItem("painel_admin_menus_auto")
    );

    if (menusSalvos && location.pathname !== "/app") {
      direcionarAcesso(menusSalvos);
    } else {
      localStorage.removeItem("painel_admin_menus_auto");
      localStorage.removeItem("painel_admin_grupo_aberto");
      carregarMenu();
    }

    setCurrentRoute(location.pathname.replace("/app/", ""));
  }, [location.pathname]);

  const direcionarAcesso = (menus) => {
    setMenus(menus);

    validarPermissao();

    // if (location.pathname === "/app") {
    //   const lastOpenGroup = JSON.parse(
    //     localStorage.getItem("painel_admin_grupo_aberto")
    //   );

    //   if (lastOpenGroup) {
    //     if (lastOpenGroup.rotaInicial)
    //       history.push(`/app/${lastOpenGroup.rotaInicial}`);
    //     saveCurrentGroup(lastOpenGroup);
    //   } else {
    //     if (menus && menus[0]) {
    //       history.push(`/app/${menus[0].rotaInicial}`);
    //       saveCurrentGroup(menus[0]);
    //     }
    //   }
    // }
  };

  const saveCurrentGroup = (group) => {
    setCurrentGroup(group);
    localStorage.setItem("painel_admin_grupo_aberto", JSON.stringify(group));
  };

  const validarPermissao = () => {
    const rota = location.pathname.split("/")[2];

    if (!rota || rota === "home") {
      setValidandoAcesso(false);
      setAcessoOk(true);
      return;
    }

    api
      .get("permissoes/validar", {
        rota,
        sistema: 1,
      })
      .then((acesso) => {
        setValidandoAcesso(false);
        setAcessoOk(acesso.permitido);
      })
      .catch((err) => console.log("error", "Erro ao validar o acesso: " + err));
  };

  const atualizarRecentes = (menu, menuPaiNome, grupoNome) => {
    menu.menuPaiNome = menuPaiNome;
    menu.grupoNome = grupoNome;

    let menusRecentesSalvos = JSON.parse(
      localStorage.getItem("painel_admin_menus_recentes")
    );

    let recentesAtualizar = [];

    if (menusRecentesSalvos && menusRecentesSalvos.length) {
      if (menusRecentesSalvos.filter((mr) => mr.id === menu.id).length > 0)
        return;
      recentesAtualizar.push(menu);
      for (let i = 0; i < 9 && menusRecentesSalvos[i]; i++) {
        recentesAtualizar.push(menusRecentesSalvos[i]);
      }
    } else {
      recentesAtualizar.push(menu);
    }

    localStorage.setItem(
      "painel_admin_menus_recentes",
      JSON.stringify(recentesAtualizar)
    );
  };

  const carregarMenu = () => {
    api
      .get("menus/exibir", { usuarioId: 4, sistema: 1 })
      .then((menus) => {
        localStorage.setItem(
          "painel_admin_menus_auto",
          JSON.stringify(menus.grupos)
        );

        direcionarAcesso(menus.grupos);
      })
      .catch((err) => console.log("error", "Erro ao carregar o menu: " + err));
  };

  if (!menus)
    return (
      <Box style={{ justifyContent: "center" }} sx={{ display: "flex" }}>
        <CircularProgress />
      </Box>
    );

  if (validandoAcesso)
    return (
      <div>
        <CircularProgress />
      </div>
    );

  if (!acessoOk)
    return (
      <div style={{ padding: 30 }}>
        <h1>Acesso não autorizado</h1>
        <h3>
          Seu usuário não tem permissão para acessar esta página. Caso o acesso
          seja necessário, entre em contato com a equipe de gerenciamento do
          sistema.
        </h3>
        <a href="/app">Ir para a página inicial</a>
      </div>
    );

  return (
    <AppContextProvider>
      <div>
        <CssBaseline />;
        <Header
          openMenu={() => setOpenMenu(!openMenu)}
          abrir={openMenu}
          userName={usuario.usuarioNome}
          menus={menus}
          currentGroup={currentGroup}
          history={history}
        />
        <Sidebar
          currentRoute={currentRoute}
          open={openMenu}
          menus={menus}
          currentGroup={currentGroup}
          setCurrentGroup={saveCurrentGroup}
          toggleBar={() => setOpenMenu(!openMenu)}
          updateRecents={atualizarRecentes}
        />
      </div>
      <Main open={openMenu}>
        <Content match={match} history={history} location={location} />
      </Main>
    </AppContextProvider>
  );
}

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 275,
    }),
  })
);
